import { useState } from 'react';
import { LucideImageOff } from 'lucide-react';
import { cn } from '~/common/utils/styleUtil';
import { useProductImageUrl } from '~/common/utils/imageUrlProvider/useImageUrl';

export function TgsArticleImage({
  articleNumber,
  celumId,
  alt,
  size = 'normal',
}: Readonly<{
  articleNumber: string;
  celumId: number | undefined;
  alt: string;
  size?: 'small' | 'normal' | 'large';
}>) {
  const [isError, setIsError] = useState(false);
  const imgSrc = useProductImageUrl(celumId);

  const containerClassBySize = {
    small: 'h-[80px] w-[80px] min-w-[80px]',
    normal: 'h-[120px] w-[120px]',
    large: 'h-[350px] w-[350px]'
  } as const;
  const imgDimensionBySize = { small: 64, normal: 104, large: 334 } as const;

  return (
    <div
      className={cn(
        'flex justify-center items-center p-2 rounded bg-white',
        containerClassBySize[size]
      )}
    >
      {imgSrc && !isError ? (
        <img
          src={imgSrc}
          title={alt}
          alt={alt}
          width={imgDimensionBySize[size]}
          height={imgDimensionBySize[size]}
          className={cn('w-fit rounded h-full')}
          onError={() => setIsError(true)}
          loading={'lazy'}
          data-testid={`article-image-${articleNumber}`}
        />
      ) : (
        <div>
          <LucideImageOff size={48} className="text-secondary" />
        </div>
      )}
    </div>
  );
}
